import { call, put, takeLatest } from 'redux-saga/effects';
import {Providers} from '../api/index';
import {toast} from "react-toastify";
import {
    REQUEST_PROVIDERS,
    loadedProviders
} from "../actions/providers.action";



export function* requestProviders({payload}) {
    try {
        let providers = yield call(() => Providers.listProviders(payload))
        yield put(loadedProviders(providers.data));
    } catch (err){
        toast.error(err.response.data.message);
    }
}

export function* watchRequestProviders() {
    yield takeLatest(REQUEST_PROVIDERS, requestProviders);
}



// WEBPACK FOOTER //
// ./src/sagas/providers.saga.js